
import ApiService from "@/core/services/api.service";


export const SET_LISTA_TIPO_PROTOCOLO = "setListTipoProtocolo";
export const SET_LISTA_TIPO_PROTOCOLO_REV = "setListTipoProtocolosRev";
export const SET_ROTA = "setRota"
export const SET_MESSAGE_ALERT = 'setMensagem'
export const SET_CALC_TIPO_PROTOCOLO = 'setCalcAliquota'
export const SET_TIPO_PROTOCOLO = "setConta"


const actions = {
    //protocolos
    async create_tipo_protocolo(context, value) {

        await ApiService.post('tipo_protocolo', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async update_tipo_protocolo(context, value) {

        await ApiService.put('tipo_protocolo/'+value.id, value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async listar_tipo_protocolo(context) {
        await ApiService.get('tipo_protocolo')
            .then(response => {
                context.commit(SET_LISTA_TIPO_PROTOCOLO, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },


 

    set_tipo_protocolo(context, item) {
        context.commit(SET_TIPO_PROTOCOLO, item)
    },

    async delete_tipo_protocolo(context, value) {


        await ApiService.delete("tipo_protocolo/" + value.id)
            .then((response) =>
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: "success",
                    message: response.data,
                })
            )
            .catch((error) =>
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: "error",
                    message: error.response.data,
                })
            );


        context.commit(SET_LISTA_TIPO_PROTOCOLO_REV, value)


    },

    set_rota(context, value) {
        context.commit(SET_ROTA, value)
    }



};
const getters = {};

const mutations = {
    [SET_CALC_TIPO_PROTOCOLO](state, value) {
        state.calc_tipo_protocolo = value
    },
    [SET_LISTA_TIPO_PROTOCOLO](state, value) {
        state.lista_tipo_protocolo = value;
    },
    [SET_LISTA_TIPO_PROTOCOLO_REV](state, value) {
        state.lista_tipo_protocolo = state.lista_tipo_protocolo.filter(
            (protocoloss) => protocoloss.id !== value.id
        );
    },
    [SET_TIPO_PROTOCOLO](state, value) {
        state.conta = value;
    },
    [SET_ROTA](state, value) {
        state.rota = value
    },
    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {

            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },

  


};

const state = {
    lista_tipo_protocolo: [],
    conta: {},
    mensagem_alert: "",
    rota: "",
    calc_tipo_protocolo: {}

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
